import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 7a5 5 0 1 1 -4.995 5.217l-.005 -.217l.005 -.217a5 5 0 0 1 4.995 -4.783z","key":"svg-0"}]]

const IconPointFilled = createReactComponent('filled', 'point-filled', 'PointFilled', __iconNode);

export default IconPointFilled;